"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Types = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
const cel = require("./CamundaExecutionListener");
const cep = require("./CamundaExtensionProperty");
const ee = require("./ExtensionElements");
__exportStar(require("./BaseElement"), exports);
__exportStar(require("./CamundaExecutionListener"), exports);
__exportStar(require("./CamundaExtensionProperty"), exports);
__exportStar(require("./DataInputAssociation"), exports);
__exportStar(require("./DataOutputAssociation"), exports);
__exportStar(require("./ExtensionElements"), exports);
__exportStar(require("./FlowNode"), exports);
// NOTE: This is only for backwards compatibility, to avoid a breaking change.
var Types;
(function (Types) {
    Types.CamundaExecutionListener = cel.CamundaExecutionListener;
    Types.CamundaExtensionProperty = cep.CamundaExtensionProperty;
    Types.ExtensionElements = ee.ExtensionElements;
})(Types = exports.Types || (exports.Types = {}));
//# sourceMappingURL=index.js.map